const getInstancePrefix = (instanceId) => {
  return `${instanceId}.`
}

export default getInstancePrefix
